import styles from './JobCardEmptyState.sass'
import React from 'react'
import cx from 'classnames'

interface JobCardEmptyStateProps {
  children?: React.ReactNode
  className?: string
  helpText?: string
  topPadding?: boolean
}

export const JobCardEmptyState = ({
  helpText,
  children,
  topPadding,
}: JobCardEmptyStateProps) => (
  <div
    className={cx(styles.root, styles.frame, topPadding && styles.topPadding)}
  >
    {helpText && <div className={styles.heading}>{helpText}</div>}
    {children && <div className={styles.cardOptions}>{children}</div>}
  </div>
)

export const JobCardEmptyStateActionDivider = () => (
  <div className={styles.divider}>|</div>
)
